<template>
    <div class="main">
        <div class="main__inner">
            <router-link to='/Introduction' class="main__box main__box1">
                <h2 class="main__tit">OSANG TECHNOLOGY</h2>
                <p class="main__desc">
                    Experience capabilities through similar business experience, establish reasonable strategies and execution plans, have a high understanding of the tasks. Experience convenient and easy O2O services with OSANG TECHNOLOGY.
                </p>
                <span class="arrow"><img src="../../assets/resource/icon/arrow-white 2.png" alt=""></span>
            </router-link>
            <router-link to='/Service' class="main__box main__box2">
                <h2 class="main__tit">OSE-eCommerce</h2>
                <p class="main__desc">
                    A stable and differentiated O2O service platform.Experience a safer and more reliable business environment with AI technology.
                </p>
                <span class="arrow"><img src="../../assets/resource/icon/arrow-white 2.png" alt=""></span>
            </router-link>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>